// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";

function PlaceOrderFooterFbCmp(Props) {
  return React.createElement("div", {
              className: "footer footer_fallback"
            }, React.createElement("p", {
                  className: "fare-detail"
                }), React.createElement("div", {
                  className: "btn-container"
                }, React.createElement(Button$Catalyst.make, {
                      text: "Back",
                      cb: (function (param) {
                          
                        }),
                      className: "btn-secondary loading-shimmer",
                      disabled: true
                    }), React.createElement(Button$Catalyst.make, {
                      text: "Next",
                      cb: (function (param) {
                          
                        }),
                      className: "btn-primary loading-shimmer",
                      disabled: true
                    })));
}

var make = PlaceOrderFooterFbCmp;

export {
  make ,
  
}
/* react Not a pure module */
